'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'motorcycle';
var width = 640;
var height = 512;
var aliases = [127949];
var unicode = 'f21c';
var svgPathData = 'M288 32l77.2 0 2.1 4.8 23.9 54.9 36-26.2 2.1-1.5 66.6 0 0 80-81.9 0 38.2 87.7c13.6-5 28.4-7.7 43.7-7.7 70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128c0-49.7 28.3-92.7 69.6-113.9l-18.1-41.5C365.6 219.9 328 273.6 328 336l0 24-56.2 0C267.6 427 212 480 144 480 73.3 480 16 422.7 16 352S73.3 224 144 224c68 0 123.6 53 127.8 120l40.2 0c0-92.8-75.2-168-168-168l-80 0 0-16 80 0c39.7 0 76.5 12.6 106.6 34l.7-.5 126.7-92.2-23.3-53.4-66.8 0 0-16zm96.6 84.4L263.7 204.3c25.4 21.8 44.9 50.5 55.4 83.1 14.3-47.5 49-86 94-105.6l-28.5-65.5zM407.1 128l72.9 0 0-48-45.4 0-36.8 26.7 9.3 21.3zM128 344l127.7 0c-4.1-58.1-52.6-104-111.7-104-61.9 0-112 50.1-112 112S82.1 464 144 464c59.2 0 107.6-45.9 111.7-104l-135.7 0 0-16 8 0zm360.7 11.2L444 252.8c-35.7 18.7-60 56.1-60 99.2 0 61.9 50.1 112 112 112s112-50.1 112-112-50.1-112-112-112c-13.1 0-25.6 2.2-37.3 6.4l44.7 102.4 3.2 7.3-14.7 6.4-3.2-7.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMotorcycle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;